import React from 'react'
import './tags.css'
export default function Tags({ title, isActive, onClick,style={} }) {
    return (
        <div style={style} className={`tags ${isActive && "active-tag"}`} onClick={onClick}>
            {title}
        </div>
    )
}

